// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables = Types.Exact<{
  rpavId: Types.Scalars['ID']['input'];
}>;


export type ConfirmDiscardDraftVersionModal_ConfirmActionMutation = { __typename?: 'Mutation', deleteReadyPlanAggregateVersion: { __typename?: 'DeleteReadyPlanAggregateVersionResult', latestReadyPlanAggregateVersion?: { __typename?: 'ReadyPlanAggregateVersion', id: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'PlanPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'DesignPackage', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
        | { __typename?: 'ProductOffering', id: string, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string } | null | undefined }
       } | null | undefined } };


export const ConfirmDiscardDraftVersionModal_ConfirmActionDocument = gql`
    mutation ConfirmDiscardDraftVersionModal_ConfirmAction($rpavId: ID!) {
  deleteReadyPlanAggregateVersion(input: {id: $rpavId}) {
    latestReadyPlanAggregateVersion {
      id
      readyPlan {
        id
        version {
          id
        }
        aggregateVersions {
          id
        }
        aggregateLatest {
          id
        }
        aggregateActive {
          id
        }
        aggregateDraft {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useConfirmDiscardDraftVersionModal_ConfirmActionMutation__
 *
 * To run a mutation, you first call `useConfirmDiscardDraftVersionModal_ConfirmActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmDiscardDraftVersionModal_ConfirmActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmDiscardDraftVersionModalConfirmActionMutation, { data, loading, error }] = useConfirmDiscardDraftVersionModal_ConfirmActionMutation({
 *   variables: {
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useConfirmDiscardDraftVersionModal_ConfirmActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfirmDiscardDraftVersionModal_ConfirmActionMutation, ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfirmDiscardDraftVersionModal_ConfirmActionMutation, ConfirmDiscardDraftVersionModal_ConfirmActionMutationVariables>(ConfirmDiscardDraftVersionModal_ConfirmActionDocument, options);
      }
export type ConfirmDiscardDraftVersionModal_ConfirmActionMutationHookResult = ReturnType<typeof useConfirmDiscardDraftVersionModal_ConfirmActionMutation>;
export type ConfirmDiscardDraftVersionModal_ConfirmActionMutationResult = ApolloReactCommon.MutationResult<ConfirmDiscardDraftVersionModal_ConfirmActionMutation>;